<template>
  <div :style="mainStyle">
      <title-header v-if="showTab" :titleArr="titleArr" :changeTab="changeTab" :tab="tabIndex"/>
      <template v-if="name==='monthly'">
        <monthly-pane
          :autoChunkMonth="autoChunkMonth"
          :dateSeparator="dateSeparator"
          :isItemBindClick="isItemBindClick"
          :dimObj="dimObj"
          :params="params"
          :isMapValue="isMapValue"
          :okLabel="okLabel"
          :clickItem="clickItem"
          :isSingleSelect="isSingleSelect"
          :showBottomButton="showBottomButton"
          :openType="openType"
          :tabObj="getTabObj(name)"
          :moduleName="moduleName"
          :provinceName="provinceName"
          :provinCode="provinCode"
          :pathwayCityCode="pathwayCityCode"
          :cityName="cityName"
          :tab="tab"
          :moduleType="moduleType"
          :oilBrand="oilBrand"
          :condition="condition"
          :roadCode="roadCode"
          :toExportDetail="toExportDetail"
          :beforeExportFunc="beforeExportFunc"
          @hideExport="hideExport"/>
      </template>
      <template v-else-if="name==='quarterly'">
        <quarterly-pane
          :autoChunkMonth="autoChunkMonth"
          :dateSeparator="dateSeparator"
          :isItemBindClick="isItemBindClick"
          :dimObj="dimObj"
          :isMapValue="isMapValue"
          :params="params"
          :okLabel="okLabel"
          :moduleType="moduleType"
          :clickItem="clickItem"
          :isSingleSelect="isSingleSelect"
          :showBottomButton="showBottomButton"
          :openType="openType"
          :tabObj="getTabObj(name)"
          :moduleName="moduleName"
          :provinceName="provinceName"
          :provinCode="provinCode"
          :pathwayCityCode="pathwayCityCode"
          :cityName="cityName"
          :tab="tab"
          :oilBrand="oilBrand"
          :condition="condition"
          :roadCode="roadCode"
          :toExportDetail="toExportDetail"
          :beforeExportFunc="beforeExportFunc"
          @hideExport="hideExport"/>
      </template>
      <template v-else-if="name==='semi-annual'">
        <semi-annual-pane
          :autoChunkMonth="autoChunkMonth"
          :dateSeparator="dateSeparator"
          :isItemBindClick="isItemBindClick"
          :dimObj="dimObj"
          :isMapValue="isMapValue"
          :moduleType="moduleType"
          :params="params"
          :okLabel="okLabel"
          :clickItem="clickItem"
          :isSingleSelect="isSingleSelect"
          :showBottomButton="showBottomButton"
          :openType="openType"
          :tabObj="getTabObj(name)"
          :moduleName="moduleName"
          :provinceName="provinceName"
          :provinCode="provinCode"
          :pathwayCityCode="pathwayCityCode"
          :cityName="cityName"
          :tab="tab"
          :oilBrand="oilBrand"
          :condition="condition"
          :roadCode="roadCode"
          :toExportDetail="toExportDetail"
          :beforeExportFunc="beforeExportFunc"
          @hideExport="hideExport"/>
      </template>
      <template v-else-if="name==='annual'">
        <annual-pane
          :autoChunkMonth="autoChunkMonth"
          :dateSeparator="dateSeparator"
          :isItemBindClick="isItemBindClick"
          :dimObj="dimObj"
          :moduleType="moduleType"
          :isMapValue="isMapValue"
          :okLabel="okLabel"
          :clickItem="clickItem"
          :isSingleSelect="isSingleSelect"
          :showBottomButton="showBottomButton"
          :openType="openType"
          :tabObj="getTabObj(name)"
          :moduleName="moduleName"
          :provinceName="provinceName"
          :provinCode="provinCode"
          :pathwayCityCode="pathwayCityCode"
          :cityName="cityName"
          :params="params"
          :tab="tab"
          :oilBrand="oilBrand"
          :condition="condition"
          :roadCode="roadCode"
          :toExportDetail="toExportDetail"
          :beforeExportFunc="beforeExportFunc"
          @hideExport="hideExport"/>
      </template>
  </div>
</template>
<script>
//增加多维导出公共对话框
import titleHeader from './components/titleHeader.vue'
import monthlyPane from './components/monthly.vue'
import quarterlyPane from './components/monthly.vue'
import semiAnnualPane from './components/monthly.vue'
import annualPane from './components/annually.vue'
import map from 'lodash/map'
import get from 'lodash/get'
import find from 'lodash/find'
import includes from 'lodash/includes'
import each from 'lodash/each'
import split from 'lodash/split'
import size from 'lodash/size'
import toInteger from 'lodash/toInteger'
import { getDimensionSource } from "./components/util.js"
export default {
  components: {
    titleHeader,
    monthlyPane,
    quarterlyPane,
    semiAnnualPane,
    annualPane,
  },
  props: {
    autoChunkMonth: {//自动拆分月
      type: Boolean,
      default: false
    },
    params:{
      type:Object,
      default(){
        return {}
      }
    },
    dateSeparator: {
      type: String,
      default: "-"
    },
    isItemBindClick: {
      type: Boolean,
      default: false
    },
    isItemBindClick: {
      type: Boolean,
      default: false
    },
    dimObj: {
      type: Object,
      default(){
        return {
          "year":new Date().getFullYear(),
          "month":'01',
          "type":'0'
        }
      },
    },
    okLabel: {
      type: String,
      default: '确认导出'
    },
    clickItem: {
      type: Function,
      default: () => {
        console.log("clickItem");
      }
    },
    isSingleSelect: {
      type: Boolean,
      default: true
    },
    isMapValue: {
      type: Boolean,
      default: false
    },
    showBottomButton: {
      type: Boolean,
      default: true
    },
    openType: {//打开类型  dialog|popover
      type: String,
      default: 'dialog'
    },
    tabNames: {//容许 显示的tab name
      type: String,
      default: 'monthly|quarterly|semi-annual|annual'
    },
    showTab: {//是否显示tab
      type: Boolean,
      default: true
    },
    title: {//容许 显示的tab name
      type: String,
      default: '请选择您需要导出数据'
    },
    moduleName: {
      type: String,
      default: ''
    },
    provinceName: {
      type: String
    },
    provinCode: {
      type: String
    },
    moduleType: {
      type: String
    },
    pathwayCityCode: {
      type: String
    },
    cityName: {
      type: String
    },
    tab: {
      type: Number
    },
    oilBrand: {
      type: String
    },
    condition: {
      type: String
    },
    roadCode: {
      type: String
    },
    toExportDetail: {
      type: [Function, String],
      default: ''
    },
    beforeExportFunc: {
      type: Function,
      default: () => true
    },
  },
  data() {
    /*var now = new Date()
    now.setMonth(now.getMonth() - 1)
    let year = now.getFullYear()
    let selecedYear = year;*/
    let selecedYear = toInteger(get(this,["dimObj","year"],2020)) ;
    let source = getDimensionSource();
    let dimensionList = [];
    let arr = split(this.tabNames,"|");
    each(source,it=>{
      if(includes(arr,it.name)){
        it.selecedYear=selecedYear;
        dimensionList.push(it);
      }
    })
    let titleArr = map(dimensionList,"label");
    //let tabIndex=0;
    let tabIndex=toInteger(get(this,["dimObj","type"],"0")) ;
    let name = get(dimensionList,[tabIndex,"name"]);
    return {
      tabIndex,
      dimensionList,
      /*titleArr:["月份","季度","半年度","年度"],*/
      titleArr,
      name,
      mouthShow: true,
    }
  },
  mounted() {
  },
  created() {
  },
  beforeDestroy() {},
  computed: {
    mainStyle(){
      return {
        textAlign:"center"
      }
    }
  },
  methods: {
    getTabObj(name) {
      let obj = find(this.dimensionList,["name",name]);
      return obj;
    },
    changeTab(index) {
      this.tabIndex = index;
      this.name = get(this,["dimensionList",index,"name"]);
    },
    hideExport() {
      this.$emit('hideExport')
    },
  }
}
</script>
